module.exports = __webpack_public_path__ + "img/icon-group.177b6b0.svg";